<ng-container *ngIf="!loading; else loadingBlock">
  <ng-content></ng-content>
</ng-container>

<ng-template #loadingBlock>
  <div class="card__loading">
    <div class="card__loading-text">
      <app-skeleton-loader variant="line" width="70%" height="16px"></app-skeleton-loader>
      <app-skeleton-loader variant="line" width="100%" height="12px"></app-skeleton-loader>
      <app-skeleton-loader variant="line" width="82%" height="12px"></app-skeleton-loader>
    </div>
  </div>
</ng-template>
